<template>
    <div class="right_question" :style="{borderTopColor: questionColor[question.questionType]}">
        <div v-if="question.questionType !== 1" :style="{backgroundImage: setImg(question.questionType)}" class="question_label">{{question.orderRange}}</div>
        <div class="question_row question_head">
            <div class="head_part">
                <span class="block" :style="{backgroundColor: questionColor[question.questionType]}"></span>
                <span v-if="question.questionType === 1" class="title">{{questionTypeMap[question.questionType]}}</span>
                <ModifyPopover v-if="question.questionType !== 1"
                               :type-list="questionTypeList"
                               @submit="questionTypeChange"
                               :data-value="question.questionType"
                               class="title"></ModifyPopover>
            </div>
            <div class="head_part">
                <button v-if="question.questionType !== 1" class="part_btn" @click="showQuestionDetail">详细</button>
                <button class="part_btn" @click="addTitleQuestion">增加</button>
                <el-dropdown trigger="click" class="drop_down" @command="command">
                    <span class="more_btn">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="question.questionType === 1">删除</el-dropdown-item>
                        <el-dropdown-item v-if="question.questionType !== 1">合并到上一题</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div v-if="question.questionType === 1" class="question_row">
            <span class="question_title">标题名称</span>
            <input class="question_input" v-model="question.questionTitle" type="text" maxlength="120" placeholder="请输入标题名称">
            <div class="question_align">
                <div class="align_item" @click="question.centerType = 1" :class="{'active': question.centerType === 1}">
                    <div class="bar"></div>
                    <div class="bar bar_2"></div>
                    <div class="bar"></div>
                    <div class="bar bar_2"></div>
                </div>
                <div class="align_item" @click="question.centerType = 2" :class="{'active': question.centerType === 2}">
                    <div class="bar"></div>
                    <div class="bar bar_2"></div>
                    <div class="bar"></div>
                    <div class="bar bar_2"></div>
                </div>
                <div class="align_item" @click="question.centerType = 3" :class="{'active': question.centerType === 3}">
                    <div class="bar"></div>
                    <div class="bar bar_2"></div>
                    <div class="bar"></div>
                    <div class="bar bar_2"></div>
                </div>
            </div>
        </div>
        <div v-if="question.questionType === 2" class="question_row">
            <type-option v-model="question.questionOption" :disabled="optionArr.length > 1" type="option"></type-option>
            <type-option v-model="question.questionSort" class="marginL_24" type="sort"></type-option>
        </div>
        <div v-if="question.questionType === 3" class="question_row">
            <type-option v-model="question.questionBlankWidth" :disabled="blankWidthArr.length > 1" type="blankWidth"></type-option>
        </div>
        <div v-if="question.questionType === 4" class="question_row">
            <type-option v-model="question.questionBackground" :disabled="backgroundArr.length > 1" type="background"></type-option>
        </div>
    </div>
</template>

<script>
    export default {
        name: "RightQuestion",
        data () {
            return {
                // 题目类型颜色
                questionColor: {
                    1: '#0DE2DA',
                    2: '#2A95F0',
                    3: '#A7DE10',
                    4: '#E39816'
                },
                questionTypeList: [{id: 2, name: '选择题'}, {id: 3, name: '填空题'}, {id: 4, name: '问答题'}],
                // 题型
                questionTypeMap:{
                    1:'标题',
                    2:'选择题',
                    3:'填空题',
                    4:'问答题'
                }
            }
        },
        props: ['question'],
        components: {
            TypeOption: () => import('./TypeOption.vue'),
            ModifyPopover: () => import('./ModifyPopover')
        },
        computed: {
            optionArr () {
                return [...new Set(this.question.detail.map(item => {
                    return item.questionOption.id
                }))]
            },
            blankWidthArr () {
                return [...new Set(this.question.detail.map(item => {
                    return item.questionBlankWidth.id
                }))]
            },
            backgroundArr () {
                return [...new Set(this.question.detail.map(item => {
                    return item.questionBackground.id
                }))]
            },
            questionOption () {
                return JSON.stringify(this.question.questionOption)
            },
            questionBackground () {
                return JSON.stringify(this.question.questionBackground)
            },
            questionBlankWidth () {
                return JSON.stringify(this.question.questionBlankWidth)
            }
        },
        watch: {
            questionOption (newV) {
                this.question.detail.forEach(item => {
                    item.questionOption = JSON.parse(newV);
                })
            },
            questionBackground (newV) {
                this.question.detail.forEach(item => {
                    item.questionBackground = JSON.parse(newV);
                })
            },
            questionBlankWidth (newV) {
                this.question.detail.forEach(item => {
                    item.questionBlankWidth = JSON.parse(newV);
                })
            },
        },
        created() {
        },
        methods: {
            questionTypeChange (data) {
                this.question.questionType = data.value;
                data.close()
            },
            setImg (type) {
                if (type === 2) {
                    return `url(${require("../../../../assets/image/intelligentCorrect/edit/question1.png")})`
                } else if (type === 3) {
                    return `url(${require("../../../../assets/image/intelligentCorrect/edit/question2.png")})`
                } else {
                    return `url(${require("../../../../assets/image/intelligentCorrect/edit/question3.png")})`
                }
            },
            showQuestionDetail () {
                this.$emit('detail')
            },
            addTitleQuestion () {
                this.$emit('addTitle')
            },
            command () {
                this.$emit('merge')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .right_question{
        border-top-width: 5px;
        border-top-style: solid;
        border-top-color: rgba(42,149,240,1);
        padding: 27px 27px 10px 27px;
        background: rgba(255,255,255,1);
        box-shadow: 0 0 8px 0 rgba(7,0,2,0.04);
        border-radius: 5px;
        margin-bottom: 20px;
        color: #333333;
        font-size: 14px;
        position: relative;
        .question_label{
            position: absolute;
            top: -8px;
            right: 20px;
            color: white;
            text-align: center;
            padding: 6px 10px;
            box-sizing: border-box;
            white-space: nowrap;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            width: 60px;
            height: 27px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-image: url("../../../../assets/image/intelligentCorrect/edit/question1.png");
        }
        .question_row{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 20px;
            .marginL_24{
                margin-left: 24px;
            }
            .question_title{
                margin-right: 16px;
                display: inline-block;
                min-width: 56px;
                text-align: right;
            }
            .question_select{
                width: 150px;
            }
            .question_input{
                padding: 0 0 0 15px;
                min-height: 32px;
                border: 1px solid rgba(224,224,224,1);
                border-radius: 3px;
                position: relative;
                font-family: msyh;
                margin-right: 15px;
                outline: none;
                width: 276px;
                box-sizing: border-box;
            }
            .question_align{
                background: rgba(236,236,236,1);
                border-radius: 6px;
                .align_item{
                    width: 33px;
                    height: 33px;
                    display: inline-block;
                    vertical-align: top;
                    padding: 10px 6px 7px 8px;
                    cursor: pointer;
                    box-sizing: border-box;
                    text-align: center;
                    &.active{
                        background: rgba(41,150,243,1);
                        border-radius: 6px;
                    }
                    .bar{
                        width: 19px;
                        height: 2px;
                        background: white;
                        border-radius: 2px;
                        margin: 0 0 2px 0;
                        padding: 0;
                        &.bar_2{
                            width: 12px;
                            margin: 0 3px 2px 3px;
                        }
                        &:last-child{
                            margin-bottom: 0;
                        }
                    }
                    &:first-child{
                        .bar_2{
                            margin: 0 0 2px 0;
                        }
                    }
                    &:last-child{
                        .bar_2{
                            margin: 0 0 2px 7px;
                        }
                    }
                }
            }
            &.question_head{
                justify-content: space-between;
                .head_part{
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    .block{
                        display: inline-block;
                        width: 4px;
                        height: 15px;
                        background: rgba(42,149,240,1);
                        margin-right: 10px;
                        position: relative;
                        vertical-align: middle;
                    }
                    .title{
                        font-size: 16px;
                        color: black;
                        font-weight: 600;
                        display: inline-block;
                        vertical-align: middle;
                    }
                    .part_btn{
                        margin-right: 15px;
                        padding: 0 5px;
                        color: rgba(33,150,243,1);
                        font-size: 14px;
                        font-weight: 600;
                        border: none;
                        background: none;
                        font-family: msyh;
                    }
                    .drop_down{
                        .more_btn{
                            outline: none;
                            cursor: pointer;
                            font-family: msyh;
                            span{
                                display: inline-block;
                                vertical-align: middle;
                                background: #000000;
                                width: 5px;
                                height: 5px;
                                margin: 0 3px;
                                border-radius: 50%;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
